"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSalesloftCampaignsMock = void 0;

var _msw = require("msw");

var getSalesloftCampaignsMock = _msw.rest.get('/api/v1/salesloft/campaigns', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      id: 1,
      name: 'Campaign 1',
      team: {
        name: 'Team 1'
      },
      gift_budget: {
        gift_min_price: 100,
        gift_max_price: 1000,
        gift_donation_price: 50,
        gift_card_price: 150
      },
      owner: {
        first_name: 'Owner 1 firstname',
        last_name: 'Owner 1 lastname'
      },
      gifts_limit: {
        remaining_amount: 10
      }
    }, {
      id: 2,
      name: 'Campaign 2',
      team: {
        name: 'Team 2'
      },
      gift_budget: {
        gift_min_price: 100,
        gift_max_price: 1000,
        gift_donation_price: 50,
        gift_card_price: 150
      },
      owner: {
        first_name: 'Owner 2 firstname',
        last_name: 'Owner 2 lastname'
      },
      gifts_limit: {
        remaining_amount: 10
      }
    }, {
      id: 3,
      name: 'Campaign 3',
      team: {
        name: 'Team 3'
      },
      gift_budget: {
        gift_min_price: 100,
        gift_max_price: 1000,
        gift_donation_price: 50,
        gift_card_price: 150
      },
      owner: {
        first_name: 'Owner 3 firstname',
        last_name: 'Owner 3 lastname'
      },
      gifts_limit: {
        remaining_amount: 10
      }
    }, {
      id: 4,
      name: 'Campaign 4',
      team: {
        name: 'Team 4'
      },
      gift_budget: {
        gift_min_price: 100,
        gift_max_price: 1000,
        gift_donation_price: 50,
        gift_card_price: 150
      },
      owner: {
        first_name: 'Owner 4 firstname',
        last_name: 'Owner 4 lastname'
      },
      gifts_limit: {
        remaining_amount: 10
      }
    }]
  }));
});

exports.getSalesloftCampaignsMock = getSalesloftCampaignsMock;